module.exports = __webpack_public_path__ + "img/bg-flow-mobile.7ee3a66a.png";